import {Alert} from "../context/AlertsContext.tsx";

export const EVENT_TYPES = {
  NEW_ALERT: 'newAlert'
}

export function newAlertEvent(alert: Alert) {
  const event = new CustomEvent(EVENT_TYPES.NEW_ALERT, {detail: alert});
  window.dispatchEvent(event);
}